import React, { useEffect, useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  Avatar,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  Collapse,
  Select,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EastIcon from "@mui/icons-material/East";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import CloseIcon from "@mui/icons-material/Close";
import { GoLinkExternal } from "react-icons/go";
import axios from "axios";
import { LoginCardModalContext } from "../../App";
import { useLangCountry } from "../../utils/getLangCountry";

const Header = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hoveredItem, setHoveredItem] = React.useState(false);
  const leaveTimeoutRef = React.useRef(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [showToolbar, setShowToolbar] = React.useState(true);
  const lastScrollY = React.useRef(0);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const navigate = useNavigate();
  const { lang } = useLangCountry();
  const [isScrolled, setIsScrolled] = useState(false);
  const currentPath = location.pathname;
  const { language, toggleLanguage, translations } = useLanguage();
  const [flagUrl, setFlagUrl] = useState(""); // fallback
  const { openLoginCardModal } = useContext(LoginCardModalContext);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // State for drawer submenu open/close
  const [drawerSubmenuOpen, setDrawerSubmenuOpen] = React.useState({
    Trading: false,
    Company: false,
  });

  const languages = [
    {
      code: "en",
      label: "English",
      flag: "/Images/card3south.png",
    },
    {
      code: "ar",
      label: "Arabic",
      flag: "/Images/Arbics.png",
    },
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobiles = useMediaQuery(theme.breakpoints.down("lg"));

  React.useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Reduced threshold to make it appear sooner
          const pageHeight =
            document.documentElement.scrollHeight - window.innerHeight;
          const scrollThreshold = pageHeight * 0.0000000001; // Reduced threshold

          if (window.scrollY > scrollThreshold) {
            setShowToolbar(false);
          } else {
            setShowToolbar(true);
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (route) => {
    setHoveredItem(false); // Close mega menu
    setDrawerOpen(false); // Close mobile drawer
    const userCountry = localStorage.getItem('userCountry');
    const currentPath = window.location.pathname;
    
    // Check if we're currently in a country-specific path
    const isInCountryPath = currentPath.includes(`/${lang}/lb`);
    
    if (route === "/") {
      if (userCountry === "lb" || isInCountryPath) {
        navigate(`/${lang}/lb`);
      } else {
        navigate(`/${lang}`);
      }
    } else if (route.startsWith("/")) {
      if (userCountry === "lb" || isInCountryPath) {
        navigate(`/${lang}/lb${route}`);
      } else {
        navigate(`/${lang}${route}`);
      }
    } else {
      navigate(route);
    }
    // window.location.reload();
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const toggleDrawerSubmenu = (menu) => {
    setDrawerSubmenuOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const open = Boolean(anchorEl);

  const handleLangClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const [lang, setLang] = React.useState("en");
  // Remove: const [lang, setLang] = useState(() => { ... });
  // Use 'lang' from useParams everywhere in this component

  const handleChange = (event) => {
    const newLang = event.target.value;
    // setLang(newLang); // This line is removed as per the edit hint
    localStorage.setItem("selectedLanguage", newLang);
    toggleLanguage(newLang);
  };

  const handleLangClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country; // e.g., 'IN'

        console.log("sdfsdfsdfsa", ipCountryCode);

        setFlagUrl(ipCountryCode);
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);

  const handleMouseEnter = (item) => {
    clearTimeout(leaveTimeoutRef.current);
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    leaveTimeoutRef.current = setTimeout(() => {
      setHoveredItem(false);
    }, 100);
  };

  const itemStyles = {
    "Forex Trade": {
      color: "#000",
      fontWeight: "600",
      fontFamily: "SF Pro Display",
    },
    "Stock Derivatives": {
      color: "#000",
      fontWeight: "600",
      fontFamily: "SF Pro Display",
    },
    Commodities: {
      color: "#000",
      fontWeight: "600",
      fontFamily: "SF Pro Display",
    },
    "Precious Metals": {
      color: "#2494C9",
      backgroundColor: "#2494c930",
      fontWeight: "500",
      fontFamily: "SF Pro Display",
    },
    Shares: {
      color: "#000",
      fontWeight: "600",
      fontFamily: "SF Pro Display",
    },
  };

  const tradingSubItems = [
    { label: "ACCOUNTS" },
    { label: translations[language]?.accountType, route: "/account" },
    { label: "MARKET" },
    { label: translations[language]?.forexTrade, route: "/forex-trading" },
    {
      label: translations[language]?.stockDerivatives,
      route: "/stock-derivatives",
    },
    { label: translations[language]?.commodities, route: "/commodities" },
    {
      label: translations[language]?.preciousMetals,
      route: "/precious-metals",
    },
    { label: translations[language]?.shares, route: "/shares" },
    ...(flagUrl !== "Lebanon"
      ? [{ label: "Crypto Currencies", route: "/cryptocurrencies" }]
      : []),
    // {
    //   label: "Crypto Currencies",
    //   route: "/cryptocurrencies",
    // },
    { label: translations[language]?.equityIndices, route: "/equity" },
    { label: translations[language]?.energies, route: "/energies" },
    { label: translations[language]?.bbcropCopyTrading, route: "#" },
    { label: translations[language]?.bbcropCompetitions, route: "#" },
    { label: "OUR OFFERINGS" },
    // { label: translations[language]?.executionPolicy, route: "#" },
    { label: translations[language]?.AllReff, route: "#" },
    { label: translations[language]?.partnerWithUs, route: "/partner" },
    { label: "PLATFORMS" },
    { label: translations[language]?.mt5Platforms, route: "#" },
    { label: translations[language]?.Platforms },
    { label: translations[language]?.mt5Platforms, route: "/mt5" },
  ];
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));
  const companySubItems = [
    { label: "COMPANY" },
    // { label: translations[language]?.whoIsBBCorp, route: "#" },
    { label: "Who is BBcorp?", route: "/who-bbcorp" },
    { label: translations[language]?.careers, route: "/careers" },
    { label: "Regulations", route: "/regulations" },
    { label: translations[language]?.legalDocuments, route: "/legal" },
    { label: translations[language]?.bbcropAwards, route: "#" },
    { label: translations[language]?.contactUs, route: "/contact" },
    { label: translations[language]?.helpCenter, route: "/help" },
  ];

  const mobileMenu = (
    <Box>
      {[
        { key: "Trading", label: translations[language]?.trading },
        { key: "Promotions", label: translations[language]?.promotions },
        { key: "Company", label: translations[language]?.company },
        { key: "Partnership", label: translations[language]?.Partnership },
        ...Array(isSmallDevice ? 7 : 5).fill({ key: "Partnership2", label: "11111" }),
      ].map(({ key, label,index }) => (
        <Box key={`${key}-${index}`} sx={{ mb: 1 }}>
          {key === "Trading" || key === "Company" ? (
            <>
              <Typography
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDrawerSubmenu(key);
                }}
                sx={{
                  mt: 2,
                  // my: 4,
                  fontWeight: "500",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  // fontFamily: "SF Pro Display",
                  alignItems: "center",
                  color: "#182230",
                  // fontSize:'24px'
                }}
              >
                {label}
                <ExpandMoreIcon
                  sx={{
                    transform: drawerSubmenuOpen[key]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.4s ease-in-out",
                    willChange: "transform",
                    // marginRight: "25px",
                    color: "grey",
                  }}
                />
              </Typography>
              {drawerSubmenuOpen[key] && (
                <Box sx={{ pl: 2, mt: 2 }}>
                  <Collapse
                    in={drawerSubmenuOpen[key]}
                    timeout={500}
                    unmountOnExit
                    sx={{ pl: 0 }}
                  >
                    <Box
                      sx={{
                        animation: "fadeSlideDown 0.5s ease",
                        "@keyframes fadeSlideDown": {
                          from: { opacity: 0, transform: "translateY(-8px)" },
                          to: { opacity: 1, transform: "translateY(0)" },
                        },
                      }}
                    >
                      {(key === "Trading"
                        ? tradingSubItems
                        : companySubItems
                      )?.map(({ label, route }) => (
                        <Typography
                          key={label}
                          // variant="body1"
                          sx={{
                            my: 2,

                            fontWeight:
                              label === translations[language]?.companyInfo ||
                                label === "ACCOUNTS" ||
                                label === "MARKET" ||
                                label === "OUR OFFERINGS" ||
                                label === "PLATFORMS" ||
                                label === "COMPANY"
                                ? 500
                                : 400,

                            cursor: "pointer",
                            // marginTop: label === "COMPANY" ||  "ACCOUNTS"  ? "30px" : "0px",
                            color:
                              label === translations[language]?.companyInfo ||
                                label === "ACCOUNTS" ||
                                label === "MARKET" ||
                                label === "OUR OFFERINGS" ||
                                label === "PLATFORMS" ||
                                label === "COMPANY"
                                ? "#98A2B3"
                                : "#182230",
                            // fontSize:
                            // label === translations[language]?.companyInfo ||
                            // label === "ACCOUNTS" ||
                            // label === "MARKET" ||
                            // label === "OUR OFFERINGS" ||
                            // label === "PLATFORMS" ||
                            // label === "COMPANY"
                            //   ? "12px !important"
                            //   : "16px",

                            fontFamily: "SF Pro Display",
                          }}
                          onClick={() => handleNavigation(route)}
                        >
                          {label}
                        </Typography>
                      ))}
                    </Box>
                  </Collapse>
                </Box>
              )}
            </>
          ) : (
            <Typography
              sx={{
                my: 3,
                fontWeight: 500,
                cursor: "pointer",
                color:
                  key === "Partnership"
                    ? "#175CD3"
                    : key === "Partnership2"
                      ? "transparent" // ✅ transparent color
                      : "#000",
                background:
                  key === "Partnership"
                    ? "#EFF8FF"
                    : key === "Partnership2"
                      ? "transparent" // ✅ no background
                      : "transparent",
                display: "flex",
                alignItems: "center",
                padding: key === "Partnership" ? "13px 10px" : "0",
                borderRadius: key === "Partnership" ? "10px" : "0px",
                justifyContent: "space-between",
              }}
              onClick={() => handleNavigation("/promotions")}
            >
              {label}
              {key === "Partnership" && (
                <GoLinkExternal
                  style={{ color: "#175CD3", fontSize: "20px" }}
                />
              )}
            </Typography>
          )}
        </Box>
      ))}
      <Box mt={3}>
        <Divider />
      </Box>
    </Box>
  );

  const renderMegaMenu = (menu) => {
    if (menu === "Trading") {
      return (
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <Typography
              variant="subtitle1"
              fontWeight="500"
              fontSize={"20px"}
              gutterBottom
            >
              {translations[language]?.Accounts}
            </Typography>
            {[
              {
                label: translations[language]?.forexTrade,
                route: "/account",
              },
            ].map(({ label, route }, idx) => {
              const isActive = currentPath === route;

              return (
                <Typography
                  key={idx}
                  variant="subtitle2"
                  onClick={() => handleNavigation(route)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mt: "22px",
                    ml: "-16px !important",
                    borderRadius: "10px",
                    px: 2,
                    py: 1,
                    backgroundColor: isActive ? "#2494c930" : "transparent",
                    fontFamily: "SF Pro Display",
                    color: isActive ? "#2494C9" : "inherit",
                    transition: "background-color 0.3s ease, color 0.3s ease", // <-- add this

                    "&:hover": {
                      backgroundColor: "#2494c930",
                      color: "#2494C9",
                      "& svg": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  {translations[language]?.accountType}
                  <EastIcon
                    fontSize="small"
                    sx={{
                      ml: 0.5,
                      transition: "opacity 0.3s",
                      opacity: isActive ? 1 : 0, // hide initially
                    }}
                  />
                </Typography>
              );
            })}
            {/* <Button
              disableRipple
              endIcon={<EastIcon fontSize="small" />}
              sx={{
                justifyContent: "space-between",
                px: 0,
                py: 1,
                mt: "15px",
                borderRadius: 2,
                color: currentPath === "/account" ? "#2494C9" : "inherit",
                textTransform: "none",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#2494c930",
                  color: "#2494C9",
                },
              }}
              onClick={() => handleNavigation("/account")}
            >
              {translations[language].accountType}
            </Button> */}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant="subtitle1"
              fontWeight="500"
              fontSize={"20px"}
              gutterBottom
              sx={{ marginLeft: { xs: "0px", md: "10px !important" } }}
            >
              {translations[language]?.market}
            </Typography>
            {[
              {
                label: translations[language]?.forexTrade,
                route: "/forex-trading",
              },
              {
                label: translations[language]?.stockDerivatives,
                route: "/stock-derivatives",
              },
              {
                label: translations[language]?.commodities,
                route: "/commodities",
              },
              {
                label: translations[language]?.preciousMetals,
                route: "/precious-metals",
              },
              { label: translations[language]?.shares, route: "/shares" },
            ].map(({ label, route }, idx) => {
              const isActive = currentPath === route;

              return (
                <Typography
                  key={idx}
                  variant="subtitle2"
                  onClick={() => handleNavigation(route)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mt: "22px",
                    ml: "-6px",
                    borderRadius: "10px",
                    px: 2,
                    py: 1,
                    backgroundColor: isActive ? "#2494c930" : "transparent",
                    fontFamily: "SF Pro Display",
                    color: isActive ? "#2494C9" : "inherit",
                    transition: "background-color 0.3s ease, color 0.3s ease", // <-- add this

                    "&:hover": {
                      backgroundColor: "#2494c930",
                      color: "#2494C9",
                      "& svg": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  {label}

                  <EastIcon
                    fontSize="small"
                    sx={{
                      ml: 0.5,
                      transition: "opacity 0.3s",
                      opacity: isActive ? 1 : 0, // hide initially
                    }}
                  />
                </Typography>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              color="transparent"
            >
              Market
            </Typography>
            {[
              ...(flagUrl !== "Lebanon"
                ? [{ label: "Crypto Currencies", route: "/cryptocurrencies" }]
                : []),
              // {
              //   label: translations[language]?.cryptoCurrencies,
              //   route: "/cryptocurrencies",
              // },
              {
                label: translations[language]?.equityIndices,
                route: "/equity",
              },
              { label: translations[language]?.energies, route: "/energies" },
            ].map(({ label, route }, idx) => {
              const isActive = currentPath === route;

              return (
                <Typography
                  variant="subtitle2"
                  key={idx}
                  onClick={() => handleNavigation(route)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mt: "22px",
                    borderRadius: "10px",
                    fontFamily: "SF Pro Display",
                    px: 2,
                    py: 1,
                    backgroundColor: isActive ? "#2494c930" : "transparent",
                    transition: "background-color 0.3s, color 0.3s",
                    color: isActive ? "#2494C9" : "inherit",
                    "&:hover": {
                      backgroundColor: "#2494c930",
                      color: "#2494C9",
                      "& svg": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  {label}
                  <EastIcon
                    fontSize="small"
                    sx={{
                      ml: 0.5,
                      transition: "opacity 0.3s",
                      opacity: isActive ? 1 : 0, // hide initially
                    }}
                  />
                </Typography>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant="subtitle1"
              fontWeight="500"
              fontSize={"20px"}
              gutterBottom
              sx={{ marginLeft: { xs: "0px", md: "17px !important" } }}
            >
              {translations[language]?.ourOffering}
            </Typography>
            {[
              // { label: translations[language]?.marginLeverage, route: "#" },
              { label: translations[language]?.Referrals, route: "#" },
              {
                label: translations[language]?.partnerWithUs,
                route: "/partner",
              },
            ].map(({ label, route }, idx) => {
              const isActive = currentPath === route;
              const isDisabled = label === translations[language]?.Referrals;

              return (
                <Typography
                  variant="subtitle2"
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: isDisabled
                      ? 'url("/Images/block-circle.cur"), not-allowed'
                      : "pointer",
                    mt: "22px",
                    borderRadius: "10px",
                    fontFamily: "SF Pro Display",
                    px: 2,
                    py: 1,
                    backgroundColor: isActive ? "#2494c930" : "transparent",

                    transition: "background-color 0.3s, color 0.3s",
                    color: isActive ? "#2494C9" : "inherit",

                    "&:hover": {
                      backgroundColor: isDisabled ? "transparent" : "#2494c930",
                      color: isDisabled ? "#000" : "#2494C9",

                      "& svg": {
                        opacity: 1,
                      },
                    },
                  }}
                  onClick={() => handleNavigation(route)}


                >
                  <span>
                    {label}
                    {label === "Referrals" && (
                      <span
                        style={{
                          marginLeft: 4,
                          color: "#667085",
                          fontWeight: "400",
                        }}
                      >
                        {translations[language]?.ReComing}
                      </span>
                    )}
                  </span>

                  <EastIcon
                    fontSize="small"
                    sx={{
                      ml: 0.5,
                      transition: "opacity 0.3s",
                      opacity: isActive ? 1 : 0, // hide initially
                      // default hidden
                      display: isDisabled ? "none" : "inline-flex", // 👈 hides icon completely
                    }}
                  />
                </Typography>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              variant="subtitle1"
              fontWeight="500"
              fontSize={"20px"}
              gutterBottom
              sx={{ marginLeft: { xs: "0px", md: "17px !important" } }}
            >
              {translations[language]?.Platforms}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: "22px",
                borderRadius: "10px",
                fontFamily: "SF Pro Display",
                px: 2,
                py: 1,
                transition: "background-color 0.3s, color 0.3s",
                "&:hover": {
                  backgroundColor: "#2494c930",
                  color: "#2494C9",

                  "& svg": {
                    opacity: 1,
                  },
                },
              }}
              onClick={() => handleNavigation("/mt5")}
            >
              {translations[language]?.mt5Platforms}
              {/* MT5 Platforms */}
              <EastIcon
                fontSize="small"
                sx={{
                  ml: 0.5,
                  transition: "opacity 0.3s",
                  opacity: 0,
                }}
              />
            </Typography>

            {/* <Typography
              variant="subtitle2"
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: "22px",
                borderRadius: "10px",
                fontFamily: "SF Pro Display",
                px: 2,
                py: 1,
                transition: "background-color 0.3s, color 0.3s",
                "&:hover": {
                  backgroundColor: "#2494c930",
                  color: "#2494C9",

                  "& svg": {
                    opacity: 1,
                  },
                },
              }}
            >
              {translations[language]?.partnerWithUs}
              <EastIcon
                fontSize="small"
                sx={{
                  ml: 0.5,
                  transition: "opacity 0.3s",
                  opacity: 0,
                }}
              />
            </Typography> */}
          </Grid>
        </Grid>
      );
    } else if (menu === "Company") {
      return (
        <>
          <Typography
            variant="subtitle1"
            fontWeight="500"
            fontSize={"20px"}
            gutterBottom
            sx={{ marginLeft: { xs: "0px", md: "12px !important" } }}
          >
            {translations[language]?.companyInfo}
          </Typography>
          {[
            // {
            //   label: translations[language]?.whoIsBBCorp,
            //   route: "#",
            // },
            {
              label: "Who is BBcorp?",
              route: "/who-bbcorp",
            },
            { label: translations[language]?.careers, route: "/careers" },
            { label: "Regulations", route: "/regulations" },
            { label: translations[language]?.legalDocuments, route: "/legal" },
            { label: translations[language]?.bbcropAwards, route: "#" },
            { label: translations[language]?.contactUs, route: "/contact" },
            { label: translations[language]?.helpCenter, route: "/help" },
          ].map(({ label, route }, idx) => {
            const isActive = currentPath === route;
            return (
              <Typography
                variant="subtitle2"
                key={idx}
                onClick={() => handleNavigation(route)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  mt: "22px",
                  borderRadius: "10px",
                  fontFamily: "SF Pro Display",
                  px: 2,
                  py: 1,
                  transition: "background-color 0.3s, color 0.3s",
                  color: isActive ? "#2494C9" : "inherit",
                  "&:hover": {
                    backgroundColor: "#2494c930",
                    color: "#2494C9",

                    "& svg": {
                      opacity: 1,
                    },
                  },
                }}
              >
                {label}
                <EastIcon
                  fontSize="small"
                  sx={{
                    opacity: 0,
                    transition: "all 0.3s ease",
                    transform: "translateX(0)",
                  }}
                />
              </Typography>
            );
          })}
        </>
      );
    }
    return null;
  };

  return (
    <Box
      onMouseLeave={handleMouseLeave}
      onMouseEnter={() => clearTimeout(leaveTimeoutRef.current)}
      sx={{
        position: "relative",
        borderBottom: "1px solid rgba(8, 7, 7, 0.15)",
      }}
    >
      <Container maxWidth="xlg">
        <AppBar
          onMouseLeave={handleMouseLeave}
          position="fixed"
          color="transparent"
          elevation={0}
          sx={{
            px: { xs: 1, md: 8 },
            py: 1,
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,

            // ✅ Show solid white when drawer is open
            backgroundColor: drawerOpen ? "#fff" : "rgba(255, 255, 255, 0.9)",

            // ✅ Valid opacity value
            opacity: 1,

            // ✅ Optional: boost z-index to stay on top
            zIndex: drawerOpen ? 1300 : 1000,

            // ✅ Disable blur when drawer is open
            backdropFilter: drawerOpen ? "none" : "blur(12px)",
            WebkitBackdropFilter: drawerOpen ? "none" : "blur(12px)",

            // ✅ Remove shadow when drawer is open
            boxShadow: drawerOpen
              ? "none"
              : showToolbar
                ? "none"
                : "0 2px 8px rgba(0, 0, 0, 0.06)",

            transition: "all 0.2s ease-in-out",
            padding: 0,
          }}
        >
          {isHome && !isMobile && (
            <Collapse in={showToolbar} timeout={100}>
              <Box sx={{ padding: { xs: "2px 0rem", md: "2px 0.0rem" } }}>
                <Toolbar
                  sx={{
                    justifyContent: "space-between",
                    transition: "all 0.3s ease",
                    opacity: showToolbar ? 1 : 0,
                    transform: `translateY(${showToolbar ? "0" : "-100%"})`,
                    backgroundColor: "transparent",
                    minHeight: "0px !important",
                  }}
                >
                  <Typography variant="h6" component="div"></Typography>
                  <Box sx={{ marginRight: "10px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography
                        // href="https://portal.bbcorp.trade/auth/jwt/sign-in"
                        // target="_blank"
                        // rel="noopener noreferrer"
                        variant="h5"
                        sx={{ cursor: "pointer", color: "#2494C9" }}
                        component="div"
                        onClick={() => navigate("/partner")}
                      >
                        {translations[language]?.partnership}
                      </Typography>
                      {/* <Select
                        value={lang}
                        onChange={handleChange}
                        size="small"
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          bgcolor: "transparent",
                          borderRadius: "12px",
                          minWidth: 125,
                          px: 1,
                          color: "#000",
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-icon": {
                            color: "#8D969A",
                          },
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            padding: "8px 0",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              bgcolor: "#fff",
                              mt: 1,
                              borderRadius: 2,
                              color: "#000",
                            },
                          },
                        }}
                      >
                        {languages?.map((langOption) => {
                          const isSelected = lang === langOption.code;
                          return (
                            <MenuItem
                              key={langOption.code}
                              value={langOption.code}
                              sx={{
                                bgcolor: isSelected ? "#f0f0f0" : "#fff",
                                fontFamily: "SF Pro Display",
                                "&:hover": {
                                  bgcolor: "#e0e0e0",
                                },
                              }}
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <Avatar
                                  src={langOption.flag}
                                  alt={langOption.label}
                                  sx={{ width: 20, height: 20 }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#000000" }}
                                >
                                  {langOption.label}
                                </Typography>
                              </Box>
                            </MenuItem>
                          );
                        })}
                      </Select> */}
                    </Box>
                  </Box>
                </Toolbar>
              </Box>
            </Collapse>
          )}
          <Toolbar sx={{ justifyContent: "space-between", width: "100%" }}>
            {!isMobile ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 4, md: 8 },
                  position: "relative",
                }}
              >
                <Box
                  component="img"
                  src="/Images/header-logo.png"
                  alt="Logo"
                  sx={{
                    height: "60px",
                    width: "60px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                  onClick={() => handleNavigation("/")}
                />
                {[
                  { key: "Trading", label: translations[language]?.trading },
                  {
                    key: "Promotions",
                    label: "Promotions",
                  },
                  { key: "Company", label: translations[language]?.company },
                ].map(({ key, label }) => {
                  const isDisabled = key === "Promotions";

                  return (
                    <Typography
                      key={key}
                      variant="h4"
                      sx={{
                        cursor: isDisabled
                          ? 'url("/Images/block-circle.cur"), not-allowed'
                          : "pointer",
                        position: "relative",
                        fontSize: "18px",
                        fontFamily: "SF Pro Display",
                        // pointerEvents: isDisabled ? "none" : "auto",
                        "&:hover": {
                          color: isDisabled ? "inherit" : "#2494C9",
                        },
                      }}
                      onMouseEnter={() => {
                        if (!isDisabled) handleMouseEnter(key);
                      }}
                    >
                      {label}
                    </Typography>
                  );
                })}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  gap: 1,
                }}
              >
                <Box
                  component="img"
                  src="/Images/header-logo.png"
                  alt="Logo"
                  sx={{
                    height: "60px",
                    width: "60px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                  onClick={() => handleNavigation("/")}
                />
                <Box sx={{ flexGrow: 1 }} />
                <IconButton onClick={toggleDrawer(!drawerOpen)}>
                  {drawerOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <Drawer
                  anchor="right"
                  open={drawerOpen}
                  onClose={toggleDrawer(false)}
                  SlideProps={{
                    timeout: { enter: 500, exit: 500 },
                  }}
                  PaperProps={{
                    sx: {
                      width: { xs: "100%", sm: "400px" },
                      background: "#fff",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "3.7rem",
                      boxShadow: "none",
                      height: "auto", // ✅ Let drawer grow with content
                      maxHeight: "100vh", // ✅ prevent overflow off-screen
                    },
                  }}
                >
                  {/* Full-height container */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    {/* Scrollable Menu Area */}
                    <Box sx={{ flex: 1, overflowY: "auto", pl: 4, pr: 2 }}>
                      {mobileMenu}
                    </Box>

                    <Box
                      display="flex"
                      justifyContent={"space-around"}
                      gap={2}
                      mt={2}
                      mx={2}
                    >
                      <Button
                        component="a"
                        href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en_IN"
                        target="_blank"
                        rel="noopener noreferrer"
                        disableRipple
                        sx={{
                          background: "#fff",
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid lightgrey",
                          cursor: "pointer",
                          gap: 1,
                          // px: 2,
                          // py: 1,
                          height: 55,
                        }}
                      >
                        <img
                          src="/Images/transPlay.png"
                          alt="Google Play"
                          style={{ width: "22px", height: "22px" }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography variant="body6">
                            Download on the
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#000",
                              fontSize: 16,
                              fontWeight: 500,
                            }}
                          >
                            {translations[language]?.footerButtonName}
                          </Typography>
                        </Box>
                      </Button>
                      <Button
                        component="a"
                        href="https://apps.apple.com/us/app/metatrader-5/id413251709"
                        target="_blank"
                        rel="noopener noreferrer"
                        disableRipple
                        sx={{
                          background: "#fff",
                          border: "1px solid lightgrey",

                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          gap: 1,
                          px: 2,
                          py: 1,
                          height: 55,
                        }}
                      >
                        <img
                          src="/Images/apple.png"
                          alt="App Store"
                          style={{ width: "35px", height: "35px" }}
                        />
                        <Box sx={{ textAlign: "left" }}>
                          <Typography variant="body6">
                            {translations[language]?.footerButton2title}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#000",
                              fontSize: 16,
                              fontWeight: 500,
                              textWrap: "nowrap",
                            }}
                          >
                            {translations[language]?.footerButton2Name}
                          </Typography>
                        </Box>
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        px: 2,
                        pt: 4,
                        paddingBottom: 8,
                        // borderTop: "1px solid #eee",
                        backgroundColor: "#fff",
                      }}
                    >
                      {/* 🔒 Login Button */}
                      <Button
                        disableRipple
                        onClick={openLoginCardModal}
                        fullWidth
                        sx={{
                          height: "48px", // ✅ Fixed height
                          borderRadius: 3,
                          px: 3,
                          mb: 2,
                          background: "#19ABE2",
                          color: "#fff",
                          fontSize: "16px",
                          textTransform: "capitalize",
                          fontFamily: "SF Pro Display",
                          fontWeight: "500",
                          textDecoration: "none",
                          "&:hover": {
                            background: "#1591c6",
                            color: "#fff",
                            textDecoration: "none",
                          },
                        }}
                      >
                        {translations[language]?.SiggnUP}
                      </Button>
                      <Button
                        disableRipple
                        href="https://portal.bbcorp.trade/auth/jwt/sign-in"
                        target="_blank"
                        rel="noopener noreferrer"
                        fullWidth
                        variant="outlined"
                        sx={{
                          mb: 1.5,
                          height: "48px", // ✅ Fixed height
                          borderRadius: 3,
                          px: 3,
                          background: "#fff",
                          border: "1px solid #1A1C1E",
                          color: "#1A1C1E",
                          fontSize: "16px",
                          textTransform: "capitalize",
                          fontFamily: "SF Pro Display",
                          fontWeight: "500",
                          "&:hover": {
                            background: "#f7f7f7",
                            textDecoration: "none",
                            color: "#1A1C1E",
                          },
                        }}
                      >
                        {translations[language]?.login}
                      </Button>
                    </Box>
                  </Box>
                </Drawer>
              </Box>
            )}

            {/* Right Side: Login & Sign Up (Only for desktop) */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography
                  component="a"
                  href="https://portal.bbcorp.trade/auth/jwt/sign-in"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="h4"
                  sx={{
                    cursor: "pointer",
                    fontSize: "18px",
                    textDecoration: "none",
                    color: "#1A1C1E",
                    "&:hover": {
                      textDecoration: "none",
                      color: "#1A1C1E",
                    },
                  }}
                >
                  {translations[language]?.login}
                </Typography>
                <Button
                  disableRipple
                  onClick={openLoginCardModal}
                  sx={{
                    borderRadius: 3,
                    px: 3,
                    py: 1,
                    background: "#19ABE2",
                    color: "#fff",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    fontFamily: "SF Pro Display",
                    fontWeight: "500",
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "none",
                      color: "#fff",
                    },
                  }}
                >
                  {translations[language]?.signUp}
                </Button>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </Container>

      {(hoveredItem === "Trading" || hoveredItem === "Company") && (
        <Box
          sx={{
            position: "fixed",
            top: showToolbar ? "110px" : "60px",
            left: 0,
            right: 0,
            zIndex: 1500,
            pointerEvents: "auto",
          }}
        >
          <Container maxWidth="xlg" sx={{ position: "relative", zIndex: 1500 }}>
            {/* 🔳 Blurred background overlay when menu is open */}
            {(hoveredItem === "Trading" || hoveredItem === "Company") && (
              <Box
                onClick={() => setHoveredItem(false)} // Optional: click to close
                sx={{
                  position: "fixed",
                  top: isHome ? (isScrolled ? 60 : 90) : isScrolled ? 60 : 60,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backdropFilter: "blur(10px)",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  zIndex: 1400,
                }}
              />
            )}

            {/* 🔽 Trading Mega Menu */}
            {hoveredItem === "Trading" && (
              <Box
                sx={{
                  position: "absolute",
                  top: isScrolled ? 15 : isHome ? -4 : -35,
                  left: isMobiles ? "30px" : "200px",
                  width: "100%",
                  backgroundColor: "#fff",
                  boxShadow: 3,
                  zIndex: 1501,
                  py: 4,
                  px: 4,
                  maxWidth: isMobiles ? "890px" : "1200px",
                  borderRadius: "25px",
                  boxShadow: "none",
                }}
                onMouseLeave={() => setHoveredItem(false)} // Optional close on mouse leave
                onMouseEnter={() => clearTimeout(leaveTimeoutRef.current)}
              >
                {renderMegaMenu("Trading")}
              </Box>
            )}

            {/* 🔽 Company Menu */}
            {hoveredItem === "Company" && (
              <Box
                sx={{
                  position: "absolute",
                  top: isScrolled ? 15 : isHome ? -4 : -35,
                  left: "440px",
                  width: "300px",
                  backgroundColor: "#fff",
                  boxShadow: 3,
                  zIndex: 1501,
                  py: 4,
                  px: 3,
                  borderRadius: "25px",
                  boxShadow: "none",
                }}
                onMouseLeave={() => setHoveredItem(false)}
                onMouseEnter={() => clearTimeout(leaveTimeoutRef.current)}
              >
                {renderMegaMenu("Company")}
              </Box>
            )}
          </Container>
        </Box>
      )}
    </Box>
  );
};

export default Header;
